import React, { useEffect, useState } from 'react'
import { Flex, Grid, GridItem, Box } from '@chakra-ui/react'
import { CustomButton, NavBar, Sidebar } from '../../components'
import MyDiv from './default.style'
import { useNavigate } from 'react-router'
import { useAuth } from '../../hooks/useAuth'
import MeetingReminderPopup from '../../views/Meetings/MeetingReminderPopup/MeetingReminderPopup'
import { useMeetingReminder } from '../../hooks/useMeetingReminder'
import { usePushNotification } from '../../hooks/usePushNotification'

const AppLayout = (props: any) => {
  const { hasPermission, loginObj } = useAuth();
  const [isActive, setIsActive] = useState(() => {
    return sessionStorage.getItem('activePortal') || 'hrlense';
  });

  const [toggleSidebar, setToggleSidebar] = useState(false)
  const navigate = useNavigate();

  const { reminderMeeting, dismissReminder } = useMeetingReminder(loginObj?.token);
  const handleSidePanel = () => {
    setToggleSidebar(!toggleSidebar)
  }


  const handleToggle = (type: string) => {
    setIsActive(type);
    sessionStorage.setItem('activePortal', type);
    if (type === 'hrlense') {
      navigate('/dashboard');
    } else if (type === 'Recruitment') {
      navigate('/recruitement-dashboard');
    }
  };

  useEffect(() => {
    sessionStorage.setItem('activePortal', isActive);
  }, [isActive]);


   usePushNotification();

  return (
    <MyDiv>
      <Grid className={toggleSidebar ? 'parent_grid_toggle' : 'parent_grid'}>
        <GridItem className="sidebar_grid">
          <Sidebar toggleSidebar={toggleSidebar} handleSidePanel={handleSidePanel} activePortal={isActive} />
        </GridItem>
        <GridItem className={toggleSidebar ? 'children_grid_toggle' : 'children_grid'}>
          <Flex alignItems='center' justifyContent='space-between' ml={8} >
            <Flex alignItems='center' columnGap={6} >
              {hasPermission("Recruitment") && (
                <>
                  <CustomButton title="Hrlense Portal" className={`${isActive === 'hrlense' ? 'active-header-action' : 'header-action'} font-poppins text_medium text_lg`} onClick={() => handleToggle('hrlense')} />
                  <CustomButton title="Recruitment Portal" className={`${isActive === 'Recruitment' ? 'active-header-action' : 'header-action'} font-poppins text_medium text_lg`} onClick={() => handleToggle('Recruitment')} />
                </>
              )}
            </Flex>
            <NavBar />
          </Flex>
          <Box mt={4} className='inner-children'>
            {props.children}
          </Box>
        </GridItem>
      </Grid>
      {reminderMeeting && (
        <MeetingReminderPopup meeting={reminderMeeting} onDismiss={dismissReminder} />
      )}

    </MyDiv>

  )
}

export default AppLayout
